<template>
    <div class="main-wrapper" @click="hidePoiList($event)">
        <div class="content-wrapper" v-loading="initLoading" element-loading-text="拼命加载中">
            <header class="customer-source-header">
                <div @click.stop="showPoiList" class="poi-wrapper">
                    <span class="poi-bar"></span>
                    <span class="poi" data-value="poiName">{{poiName}}</span>
                    <span class="img-icon" :class="{'img-rotate': show}"></span>
                </div>
                <div class="poi-select" v-bind:class="{'poi-select1': show}">
                    <div class="poi-input-container">
                        <div class="triangle"></div>
                        <input id="poiInput" type="text" v-model="searchPoi" class="poi-input"
                               @keyup="search(searchPoi)" placeholder="请输入">
                    </div>
                    <ul class="poi-list">
                        <li @click="getPoiList(poi)" v-for="poi in poiList">
                            {{poi.poiName}}
                        </li>
                    </ul>
                </div>
                <div class="time-header-time">
                    <ul>
                        <li :class="{'active' : selectedIndex === 0 }" @click="selectTime(0,1)">昨天</li>
                        <li :class="{'active' : selectedIndex === 1 }" @click="selectTime(1,7)">本周</li>
                        <li :class="{'active' : selectedIndex === 2 }" @click="selectTime(2,30)">本月</li>
                        <li v-on:click="selectDefineTime(3)" :class="{'active' : selectedIndex === 3 }">
                            <range-datepicker :options='dateInputOption' :color="color" :bgColor="bgColor"
                                              :disableColor="disableColor" v-model="dateRange"
                                              placeholder="自定义时段"></range-datepicker>
                        </li>
                    </ul>
                </div>
                <div>
                    <div class="place" :class="{'active' : region === 2 }" v-on:click="selectRegion(2)">省份</div>
                    <div class="place" :class="{'active' : region === 1 }" v-on:click="selectRegion(1)">城市</div>
                </div>
            </header>
            <div class="diagram">
                <pie-gram v-if="dataList.length&&region === 2" :dataList="dataList" class="left-gram"></pie-gram>
                <div :class="[region === 1?'all-table-wrapper':'','table-wrapper']">
                    <data-table v-if="dataList.length&&region===2" class="inner-table" :dataList="dataList"
                                :showTd="showTable" v-on:tableModal="tableMask"></data-table>
                    <data-table v-if="region===1&&tableDataList.length" class="inner-table"
                                :dataList="tableDataList"></data-table>
                </div>
            </div>
            <hr v-if="description||subDescription"/>
            <div v-if="description||subDescription" class="desc-wrapper">
                <img class="descIcon" src="~static/img/group-26.png" alt="icon">
                <div class="description">
                    <div>{{description}}</div>
                    <div style="fontSize:12px;">{{subDescription}}</div>
                </div>
            </div>
        </div>
        <div class="content-wrapper intergap">
            <div class="header">
                <span class="poi-bar poi-bar-diff"></span>
                <span class="poi poi-diff" type="text">景区客源VS省份客源</span>
                <div class="time-header-time month-date">近30天</div>
            </div>
            <div class="flex-box">
                <div class="left-container">
                    <span class="province-poi" data-value="poiName">{{poiName}}</span>
                    <data-map :id="mapIdOne" :dataList="poiOtherProvinces"></data-map>
                    <data-table v-if="poiOtherProvinces.length" :dataList="poiOtherProvinces.slice(0,10)"
                                :showTd="showTd"></data-table>
                </div>
                <div class="middle-container"></div>
                <div class="right-container">
                    <span class="province-poi" data-value="provinceName">{{provinceName}}</span>
                    <data-map v-if="allOtherProvinces.length" :id="mapIdTwo" :dataList="allOtherProvinces"></data-map>
                    <data-table v-if="allOtherProvinces.length" :dataList="allOtherProvinces.slice(0,10)"
                                :showTd="showTd"></data-table>
                </div>
            </div>
            <div v-if="provinceDescription&&provinceDescription.length" class="desc-wrapper">
                <img class="descIcon" src="~static/img/group-26.png" alt="icon">
                <div class="description" :class="{'vertical-center': provinceDescription.length===1}">
                    <div v-for="item in provinceDescription">{{item}}</div>
                </div>
            </div>
            <hr v-if="provinceDescription&&provinceDescription.length"/>
            <div class="flex-box">
                <div class="left-container">
                    <data-table :cityText="cityText" v-if="poiOtherCities.length" style="margin-top:0px;"
                                :dataList="poiOtherCities" :showTd="showTd"></data-table>
                </div>
                <div class="middle-container"></div>
                <div class="right-container">
                    <data-table :cityText="cityText" style="margin-top:0px;" v-if="allOtherCities.length"
                                :dataList="allOtherCities" :showTd="showTd"></data-table>
                </div>
            </div>
            <div v-if="cityDescription&&cityDescription.length" class="desc-wrapper">
                <img class="descIcon" src="~static/img/group-26.png" alt="icon">
                <div class="description" :class="{'vertical-center': cityDescription.length===1}">
                    <div v-for="item in cityDescription">{{item}}</div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="showTableMask"></div>
        <div class="tableModal" v-if="showTableMask">
            <div class="table-header">
                <span>{{tableTitle}}</span>
                <span class="iconfont" @click="hideTableModal">&#xe624;</span>
            </div>
            <data-table class="outer-table" v-if="cityDataList.length" :tableText="tableText" :changeClass="changeClass"
                        :dataList="cityDataList"></data-table>
        </div>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" scoped>
    @font-face {
        font-family: "iconfont"; /* project id 458209 */
        src: url("//at.alicdn.com/t/font_458209_3uc20s528f6crf6r.eot");
        src: url("//at.alicdn.com/t/font_458209_3uc20s528f6crf6r.eot?#iefix") format("embedded-opentype"),
        url("//at.alicdn.com/t/font_458209_3uc20s528f6crf6r.woff") format("woff"),
        url("//at.alicdn.com/t/font_458209_3uc20s528f6crf6r.ttf") format("truetype"),
        url("//at.alicdn.com/t/font_458209_3uc20s528f6crf6r.svg#iconfont") format("svg");
    }

    .iconfont {
        font-family: "iconfont";
        float: right;
        font-size: 14px;
    }

    .main-wrapper {
        padding: 20px;
        background-color: #f7f9fa;

    .content-wrapper {
        border-radius: 2px;
        background-color: #ffffff;
        box-shadow: 0 1px 8px 0 rgba(201, 226, 239, 0.27);
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
        "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        overflow: hidden;
        padding: 30px;

    .customer-source-header {
        position: relative;

    .poi-wrapper {
        display: inline-block;
        height: 23px;
        margin-bottom: 30px;
        position: relative;

    .img-icon {
        width: 20px;
        display: inline-block;
        height: 12px;
        background: url("~static/img/Combined-Shape-Copy7.png") no-repeat center;
    }

    .img-rotate {
        transform: rotate(180deg);
    }

    }
    .poi-bar {
        display: inline-block;
        width: 4px;
        height: 20px;
        background-color: #2ca4f7;
        vertical-align: sub;
    }

    .poi {
        padding-left: 6px;
        font-size: 20px;
        font-weight: 500;
        display: inline-block;
        height: 24px;
    }

    .poi-select {
        display: none;
        transition: all 1s linear;

    .poi-list {
        height: 300px;
        overflow: auto;
    }

    }
    .poi-select1 {
        width: 254px;
        background-color: #ffffff;
        box-shadow: 0 4px 15px 0 rgba(164, 174, 183, 0.39);
        position: absolute;
        display: block;
        z-index: 9999;

    .poi-input-container {
        padding: 10px;

    .triangle {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid #fff;
        border-top: 10px solid #fff;
        border-bottom: 10px solid transparent;
        z-index: 3;
        top: -10px;
        left: 190px;
        transform: rotate(315deg);
        box-shadow: 2px -2px 2px rgba(235, 235, 235, 0.39);
    }

    .poi-input {
        position: relative;
        outline: none;
        width: 234px;
        height: 34px;
        border-radius: 100px;
        border: solid 0.5px #c6cacf;
        z-index: 4;
    }

    }
    ul {
        margin: 0px;
        padding: 0px;
    }

    li {
        list-style: none;
        height: 44px;
        line-height: 44px;
        padding-left: 34px;
        cursor: pointer;
    }

    li:hover {
        background-color: #e7f4ff;
    }

    }
    .time-header-time {
        position: absolute;
        right: 20px;
        top: -15px;
        text-align: center;

    li {
        width: 90px;
        height: 32px;
        border: solid 0.5px #c6cacf;
        float: left;
        list-style: none;
        font-size: 14px;
        line-height: 32px;
        letter-spacing: 0.3px;
        text-align: center;
        color: #4c4e50;
        border-right: none;
        cursor: pointer;
        text-align: center;
    }

    li:last-child,
    li:last-child input {
        width: 186px;
        border-right: solid 0.5px #c6cacf;
    }

    li input {
        text-align: center;
        border: none;
        outline: none;
        height: 28px;
    }

    li input::-webkit-input-placeholder {
        color: #4c4e50;
    }

    li.active {
        border-radius: 2px;
        background-color: #2ca4f7;
        color: #ffffff;
    }

    li:last-child.active,
    li:last-child.active input {
        color: #4c4e50;
        background-color: #fff;
    }

    }
    .place {
        width: 102px;
        height: 32px;
        line-height: 32px;
        border-radius: 16px;
        background-color: #ffffff;
        border: solid 0.5px #c6cacf;
        cursor: pointer;
        text-align: center;
        display: inline-block;
        margin-top: 0px;
        margin-right: 5px;
    }

    div.active {
        background-color: #2ca4f7;
        color: #ffffff;
    }

    }
    .diagram {
        margin-top: 30px;
        overflow: hidden;

    .left-gram {
        vertical-align: center;
        width: 30%;
        float: left;
    }

    .table-wrapper {
        width: 65%;
        float: right;

    .inner-table {
        border-radius: 2px;
        border: solid 0.5px #e9eef0;
    }

    }
    .all-table-wrapper {
        width: 100%;
    }

    }
    .descIcon {
        display: inline-block;
        vertical-align: top;
    }

    .desc-wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .description {
        display: inline-block;
        margin-left: 18px;
        font-size: 18px;
        color: #142c3d;

    div:nth-child(n + 2) {
        margin-top: 2.5px;
    }

    }
    .vertical-center {
        margin-top: 10px;
    }

    }
    .intergap {
        margin-top: 20px;

    .poi-diff {
        border: none;
        padding: 0 0 0 15px;
        margin-bottom: 20px;
        padding-left: 13px !important;
    }

    .poi-bar-diff {
        position: absolute;
        top: 4px;
    }

    .month-date {
        background-color: #2ca4f7;
        color: #ffffff;
        width: 88px;
        height: 32px;
        border: solid 0.5px #c6cacf;
        font-size: 14px;
        line-height: 32px;
        letter-spacing: 0.3px;
        text-align: center;
        margin-top: 9px;
    }

    }
    .flex-box {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 20px;

    .left-container {
        flex: 1;
    }

    .middle-container {
        width: 1px;
        margin-right: 20px;
        margin-left: 20px;
        background-color: #e9eef0;
    }

    .right-container {
        flex: 1;

    .shorter {
        width: 15%;
    }

    }
    .province-poi {
        display: inline-block;
        text-align: center;
        height: 40px;
        margin-top: 10px;
        padding: 0 13px 0 13px;
        line-height: 40px;
        font-size: 18px;
        border-radius: 2px;
        border: solid 0.5px #c6cacf;
    }

    }
    .mask {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    .tableModal {
        width: 50%;
        padding: 30px;
    / / height: 60 %;
        position: absolute;
        left: 25%;
        top: 100px;
        background-color: #fff;

    .table-header {
        font-weight: 500;
        font-size: 20px;
        line-height: 22px;
        margin-bottom: 30px;
        & .iconfont{
            cursor: pointer;
        }
    }

    .outer-table {
        border-radius: 2px;
        border: solid 0.5px #e9eef0;
    }

    }
    }
</style>
<script>
    // require("flatpickr/dist/themes/material-blue.css");
    import {
        getPoi,
        getPoiSales,
        getPoiSalesInProvince,
        getPoiSalesInProvinceCity
    } from "api/customerSourceAnalyse";
    import PieGram from "./echarts/pie.vue";
    import DataMap from "./echarts/map.vue";
    import toFixedPercent from "filters/toFixedPercent.js";
    import dataTable from "./table.vue";
    import rangeDatepicker from 'components/datepicker/index'
    export default {
        components: {
            PieGram,
            DataMap,
            dataTable,
            rangeDatepicker
        },
        data() {
            return {
                poiList: [],
                //省份客源
                dataList: [],
                initLoading: true,
                tableDataList: [], //城市客源
                poiOtherProvinces: [], //省份維度的poi省份客源,
                allOtherProvinces: [], //省份維度的省份客源,
                poiOtherCities: [], //省份維度的省外城市poi客源,
                allOtherCities: [], //省份維度的省外城市省份客源,
                cityDataList: [],
                tableTitle: "",
                provinceId: "",
                color: '#fff',
                bgColor: "#1da1ff",
                disableColor: "#ccc",
                changeClass: true,
                showTableMask: false,
                tableText: true,
                cityText: true,
                poiName: "",
                provinceName: "",
                selectedIndex: 2,
                searchPoi: "",
                poiId: "",
                region: 2,
                showTable: true,
                showTd: false,
                mapIdOne: "chartsMapOne",
                mapIdTwo: "chartsMapTwo",
                show: false,
                description: "",
                subDescription: "",
                provinceDescription: [],
                cityDescription: [],
                searchInfo: false,
                dateInputOption: {
                    mode: "range",
                    maxDate: this.getDateTime(new Date(new Date().valueOf())),
                    onClose: function (value) {
                        this.getDateRange();
                    }.bind(this)
                },
                dateRange: "",
                startDate: this.getDateTime(
                    new Date(new Date().valueOf() - 30 * 24 * 60 * 60 * 1000)
                ),
                endDate: this.getDateTime(new Date(new Date().valueOf()))
            };
        },
        created: function () {
            this.getPoi().then(i => {
                setTimeout(() => {
                    this.initLoading = false;
                }, 600);
                this.poiName = this.poiList[0].poiName;
                this.poiId = this.poiList[0].poiId;
                this.provinceName = this.poiList[0].provinceName;
                this.getPoiSales();
                this.getPoiSalesInProvince();
            });
        },
        watch: {
            startDate: function () {
                this.getPoiSales();
            },
            endDate: function () {
                this.getPoiSales();
            },
            poiId: function () {
                this.getPoiSales();
                this.getPoiSalesInProvince();
            },
            provinceId: function () {
                this.getPoiSalesInProvinceCity();
            }
        },
        methods: {
            showPoiList() {
                this.show = true;
                this.getPoi();
            },
            hidePoiList(e) {
                if (e.target.id !== "poiInput") {
                    this.show = false;
                }
            },
            getPoiList(poi) {
                if (poi.poiName && poi.poiName.indexOf("无对应匹配项") === -1) {
                    this.poiName = poi.poiName;
                    this.poiId = poi.poiId;
                    this.provinceName = poi.provinceName;
                    this.show = false;
                }
                this.getPoiSales();
            },
            getPoi() {
                return getPoi()
                    .then(response => {
                        if (response.status === 0) {
                            if (response.data) {
                                this.poiList = response.data.poiInfos;
                                this.searchInfo = true;
                            }
                        } else {
                            this.alert(response.message || "接口返回信息有误");
                        }
                    })
                    .catch(error => {
                        this.searchInfo = false;
                        this.poiList = [];
                        this.alert(error);
                    });
            },
            getPoiSales() {
                return getPoiSales({
                    poiId: this.poiId,
                    region: this.region,
                    startDate: this.startDate,
                    endDate: this.endDate
                })
                    .then(response => {
                        if (response.status === 0) {
                            if (response.data) {
                                if (this.region === 2) {
                                    this.dataList = response.data.ratioInfos;
                                    this.dataList = this.convertName(this.dataList);
                                }
                                if (this.region === 1) {
                                    this.tableDataList = response.data.ratioInfos;
                                }
                                this.description = response.data.desc;
                                this.subDescription = response.data.subDesc;
                            }
                        } else {
                            this.alert(response.message || "接口返回信息有误");
                        }
                    })
                    .catch(error => {
                        this.dataList = [];
                        this.alert(error);
                    });
            },
            getPoiSalesInProvince() {
                getPoiSalesInProvince({
                    poiId: this.poiId
                })
                    .then(response => {
                        if (response.status === 0) {
                            if (response.data) {
                                this.poiOtherProvinces = this.convertName(response.data.poiOtherProvinces);
                                this.allOtherProvinces = this.convertName(response.data.allOtherProvinces);
                                this.allOtherCities = this.convertName(response.data.allOtherCities.slice(0, 10));
                                this.poiOtherCities = this.convertName(response.data.poiOtherCities.slice(0, 10));
                                this.provinceDescription = response.data.provinceDescs;
                                this.cityDescription = response.data.cityDescs;
                            }
                        } else {
                            this.alert(response.message || "接口返回信息有误");
                        }
                    })
                    .catch(error => {
                        this.poiList = [];
                        this.alert(error);
                    });
            },
            getPoiSalesInProvinceCity() {
                getPoiSalesInProvinceCity({
                    poiId: this.poiId,
                    provinceId: this.provinceId,
                    startDate: this.startDate,
                    endDate: this.endDate
                })
                    .then(response => {
                        if (response.status === 0) {
                            if (response.data) {
                                this.cityDataList = response.data.saleRatioInfos;
                            }
                        } else {
                            this.alert(response.message || "接口返回信息有误");
                        }
                    })
                    .catch(error => {
                        this.poiList = [];
                        this.alert(error);
                    });
            },
            selectTime(index, day) {
                let today = new Date();
                let nowVal = today.valueOf();
                let TimeStart = new Date(nowVal - day * 24 * 60 * 60 * 1000);
                this.startDate = this.getDateTime(TimeStart);
                this.endDate = this.getDateTime(today);
                this.selectedIndex = index;
                if (this.selectedIndex !== 3) {
                    this.dateRange = "自定义时段";
                }
                this.getPoiSales();
            },
            getDateTime(date) {
                let result = "";
                if (date) {
                    result += date.getFullYear();
                    let month = date.getMonth() + 1;
                    result += month < 10 ? "0" + month : month;
                    let dateInMonth = date.getDate();
                    result += dateInMonth < 10 ? "0" + dateInMonth : dateInMonth;
                }
                return result;
            },
            selectRegion(region) {
                this.region = region;
                this.getPoiSales();
            },
            alert(message) {
                this.$alert({
                    title: "提示",
                    message: message,
                    showCancelButton: false,
                    closeOnClickModal: false
                });
            },
            search(text) {
                let str = text.replace(/^\s+|\s+$/g, "");
                let searchArr = [];
                if (!str) {
                    this.getPoi();
                }
                this.poiList.forEach(element => {
                    if (element.poiName.indexOf(str) !== -1) {
                        searchArr.push(element);
                    }
                });
                if (str && searchArr.length === 0) {
                    this.poiList = [{poiName: "无对应匹配项"}];
                } else if (str && searchArr.length) {
                    this.poiList = searchArr;
                }
            },
            tableMask(item) {
                let str = "省内销量分布";
                this.tableTitle = item.name + str;
                this.provinceId = item.provinceId;
                this.getPoiSalesInProvinceCity();
                this.showTableMask = true;
                //this.alert(name)
            },
            hideTableModal() {
                this.showTableMask = false;
            },
            convertName(arr) {
                let tempArr = [];
                arr.forEach(item => {
                    let tempName = item.name.replace(
                        /(省|自治区|维吾尔自治区|壮族自治区|回族自治区|特别行政区|市)$/g, "");
                    if (arr === this.dataList) {
                        tempArr.push({
                            name: tempName,
                            ratio: item.ratio,
                            provinceId: item.provinceId
                        });
                    } else {
                        tempArr.push({name: tempName, ratio: item.ratio});
                    }
                });
                return tempArr;
            },
            getDateRange() {
                let arr =
                    this.dateRange.indexOf("~") !== -1
                        ? this.dateRange.split(" ~ ")
                        : ["", ""];
                if (arr[0] && arr[1]) {
                    this.startDate = arr[0].replace(/-/g, "");
                    this.endDate = arr[1].replace(/-/g, "");
                    this.getPoiSales();
                }
            },
            selectDefineTime() {
                this.selectedIndex = 3;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// customerSourceAnalyse.vue?fd195316